import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box } from '@mui/material';
import { useState } from 'react';
import { useRootStore } from '../hooks/useRootStore';

export interface NewActivityData {
    comment: string,
    timeStart: Date,
    timeEnd: Date,
}

export default function AcceptIssueDialog({ issueId, initialEstimatedHours, onSubmit, onCancel }: { issueId: number, initialEstimatedHours: number | undefined, onSubmit: (estimatedHours: number) => void, onCancel: () => void }) {
    const [estimatedHoursNotSpecified, setEstimatedHoursNotSpecified] = useState(false);
    const [estimatedHours, setEstimatedHours] = useState(initialEstimatedHours);
    const { api } = useRootStore();

    const acceptIssue = async () => {
        if (!estimatedHours) {
            setEstimatedHoursNotSpecified(true);            
            return false;
        }

        setEstimatedHoursNotSpecified(false);

        await api.acceptIssue(issueId, estimatedHours!)
            .then(() => onSubmit(estimatedHours!));
    }

    return (
        <Box>
            <Dialog open={true} onClose={onCancel}>
                <DialogTitle>Принять задачу в работу</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Укажите запланированную продолжительность работ в часах
                    </DialogContentText>
                    <TextField
                        sx={{ margin: '0 auto', mt:2, width: '100%' }}
                        id="outlined-number"
                        type="number"
                        required
                        error={estimatedHoursNotSpecified}
                        defaultValue={ initialEstimatedHours }
                        onChange={(e) =>
                            setEstimatedHours(e.target.value as unknown as number)
                        }
                        slotProps={{
                            inputLabel: {
                                shrink: true,
                            },
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onCancel}>Отмена</Button>
                    <Button onClick={acceptIssue}>В работу</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}